/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseClient } from '../base-client';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createMailingList } from '../fn/create-mailing-list-dialog/create-mailing-list';
import { CreateMailingList$Params } from '../fn/create-mailing-list-dialog/create-mailing-list';
import { CreateMailingListDialogDataDto as FeatureMailingListsCreateMailingListDialogDataDto } from '../models/feature/mailing-lists/create-mailing-list-dialog-data-dto';
import { MailingListDto as FeatureMailingListsMailingListDto } from '../models/feature/mailing-lists/mailing-list-dto';
import { getData } from '../fn/create-mailing-list-dialog/get-data';
import { GetData$Params } from '../fn/create-mailing-list-dialog/get-data';

@Injectable({ providedIn: 'root' })
export class CreateMailingListDialogClient extends BaseClient {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `createMailingListDialogGetData()` */
  static readonly CreateMailingListDialogGetDataPath = '/create-mailing-list-dialog';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getData()` instead.
   *
   * This method doesn't expect any request body.
   */
  getData$Response(context?: HttpContext): Observable<StrictHttpResponse<FeatureMailingListsCreateMailingListDialogDataDto>> {
    const obs = getData(this.http, this.rootUrl, {} satisfies GetData$Params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getData$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getData(context?: HttpContext): Observable<FeatureMailingListsCreateMailingListDialogDataDto> {
    const resp = this.getData$Response(context);
    return resp.pipe(
      map((r: StrictHttpResponse<FeatureMailingListsCreateMailingListDialogDataDto>): FeatureMailingListsCreateMailingListDialogDataDto => r.body)
    );
  }

  /** Path part for operation `createMailingListDialogCreateMailingList()` */
  static readonly CreateMailingListDialogCreateMailingListPath = '/create-mailing-list-dialog';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createMailingList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createMailingList$Response(body: CreateMailingList$Params['body'], context?: HttpContext): Observable<StrictHttpResponse<FeatureMailingListsMailingListDto>> {
    const obs = createMailingList(this.http, this.rootUrl, { body } satisfies CreateMailingList$Params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createMailingList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createMailingList(body: CreateMailingList$Params['body'], context?: HttpContext): Observable<FeatureMailingListsMailingListDto> {
    const resp = this.createMailingList$Response(body, context);
    return resp.pipe(
      map((r: StrictHttpResponse<FeatureMailingListsMailingListDto>): FeatureMailingListsMailingListDto => r.body)
    );
  }

}
